// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/colors/index.scss
// module id = 249
// module chunks = 0